import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import "./switch.script";
export function RuiSwitch({
  children,
  checked,
  disabled,
  name,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-switch", {
    ...props,
    checked,
    disabled,
    name,
    children: /* @__PURE__ */jsxs("label", {
      class: "rui-switch",
      children: [/* @__PURE__ */jsx("input", {
        type: "checkbox",
        role: "switch",
        "data-ref": "input",
        "data-rui-control": true,
        "data-rui-control-type": "boolean",
        class: "rui-switch__input",
        checked,
        disabled,
        name: name || void 0
      }), /* @__PURE__ */jsx("span", {
        class: "rui-switch__track",
        "aria-hidden": "true",
        children: /* @__PURE__ */jsx("span", {
          class: "rui-switch__thumb"
        })
      }), /* @__PURE__ */jsx("span", {
        class: "rui-switch__label",
        children
      })]
    })
  });
}